<template>
  <div class="shade" v-show="model" :style="{opacity:activeNumber}">
    <div class="content" :style="{zoom:activeNumber,opacity:activeNumber}" @click="$event.stopPropagation()">
      <i @click="close" class="delete">&#10006;</i>
      <div class="content-w" :style="{'overflowY':overflowY}">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PopUp",
    props:{
      value:{
        type:Boolean,
        default:false,
      },
      //下拉框超过高度 'visible'
      overflowY:{
        type:String,
        default:'auto'
      }
    },
    data() {
      return {
        activeNumber:1,
        model:this.value
      }
    },
    watch:{
      value:function (val) {
        this.model = val
      },
      model:function (val) {
        this.$emit('input',val)
      }
    },
    methods:{
      close(){
        var ss = 1
        var _this = this
        var timer = setInterval(function(){
          _this.activeNumber = ss
          if(ss<0.5){
            _this.activeNumber = 1
            _this.model = false
            clearInterval(timer);
          }else{
            ss = ss-0.05
          }
        },10);

      }
    }
  }
</script>

<style lang="less" scoped>
  .shade{
    position: fixed;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.5);
    z-index: 100;
  }
  .content{
    position: absolute;
    background: #fff;
    padding: 20px;
    top:10%;
    left:50%;
    border:1px solid #656565;
    box-shadow: 0 0 10px #656565;
    border-radius: 6px;
    transform:translate(-50%,0);
    animation: scale .3s;
    -moz-animation: scale .3s;
    -webkit-animation: scale .3s;
  }
  @keyframes scale {0%   {transform:scaleY(0) translate(-50%,0);opacity:0} 100% {transform:scaleY(1) translate(-50%,0);opacity:1} }
  @-moz-keyframes scale {0%   {transform:scaleY(0) translate(-50%,0);opacity:0} 100% {transform:scaleY(1) translate(-50%,0);opacity:1} }
  @-webkit-keyframes scale {0%   {transform:scaleY(0) translate(-50%,0);opacity:0} 100% {transform:scaleY(1) translate(-50%,0);opacity:1} }
  .delete{
    position: absolute;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 28px;
    font-size: 16px;
    top:0;
    right:0;
    color:red;
    cursor:pointer;
  }
  .content-w{
    max-height: 500px;
  }
</style>
